var document = require('./_global').document;
module.exports = document && document.documentElement;



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/modules/_html.js